import { apiClientV2 } from '@/services/rest-api/apiClient'
const baseURL = process.env.VUE_APP_API_FINANCIAL_RECORD_URL

const _get = async (queryParamFilters, queryParam, setParams, setMetadata) => {
  const params = {
    limit: queryParam.limit,
    page: queryParam.page,
    sorts: queryParam?.sorts?.length > 0 ? queryParam.sorts : undefined,
    search: queryParam?.search || undefined,
    filters: queryParamFilters || undefined,
  }

  setParams?.(params)

  const response = await apiClientV2({
    method: 'GET',
    baseURL,
    url: '/transaction',
    params: params,
  })

  setMetadata?.(response?.data.metadata)

  return response?.data
}

export const get = (queryParamFilters, setParams, setMetadata) => async (queryParam) =>
  await _get(queryParamFilters, queryParam, setParams, setMetadata)

export const show = async (id) => {
  const response = await apiClientV2({
    method: 'GET',
    baseURL,
    url: `/transaction/${id}`,
    params: { item: true }
  })

  return response?.data
}

export const store = async (data) => {
  const response = await apiClientV2({
    method: 'POST',
    baseURL,
    url: '/transaction',
    data,
  })

  return response?.data
}

export const update = async (fleetTaskId, data) => {
  const response = await apiClientV2({
    method: 'PATCH',
    baseURL,
    url: `/transaction/${fleetTaskId}`,
    data,
  })

  return response?.data
}

export const deleteMany = async (data) => {
  const response = await apiClientV2({
    method: 'DELETE',
    baseURL,
    url: '/transaction/bulk',
    data,
  })

  return response?.data
}

export const getItems = async (id, params) => {
  const { data: { data } } = await apiClientV2({
    method: 'GET',
    baseURL,
    url: `/transaction/${id}`,
    params
  })

  return data.transaction_item
}

export const downloadAccurate = async (params) => {
  const { data } = await apiClientV2({
    method: 'GET',
    baseURL,
    url: '/transaction/export/accurate/other-payment',
    responseType: 'blob',
    params
  })

  return data
}

export const compare = async (id, params) => {
  const { data } = await apiClientV2({
    method: 'GET',
    baseURL,
    url: `/transaction/${id}/compare-external`,
    params
  })

  return data
}

export const submitToAccurate = async (data) => {
  const response = await apiClientV2({
    method: 'POST',
    baseURL,
    url: '/transaction/external',
    data,
  })

  return response?.data
}

export const saveAsDefault = async (data) => {
  const response = await apiClientV2({
    method: 'POST',
    baseURL,
    url: '/default-value',
    data,
  })

  return response?.data
}

export const getDefaultValue = async () => {
  const response = await apiClientV2({
    method: 'GET',
    baseURL,
    url: '/default-value/funds_account_source'
  })

  return response?.data
}
